
  export default {
    data() {
      return {
        discountSwitch: false,
        contingents: [
          {
            color: '#E4BF7B',
            name: '50 Kontakte',
            price_per_contact: '4,50 €',
            discounted_price_per_contact: '3,38 €',
            price_per_quota: '225,00 €',
            discounted_price_per_quota: '168,75 €',
          },
          {
            color: '#DCA441',
            name: '100 Kontakte',
            price_per_contact: '4,00 €',
            discounted_price_per_contact: '3,00 €',
            price_per_quota: '400,00 €',
            discounted_price_per_quota: '300,00 €',
          },
          {
            color: '#6E8DB5',
            name: '250 Kontakte',
            price_per_contact: '3,50 €',
            discounted_price_per_contact: '2,63 €',
            price_per_quota: '875,00 €',
            discounted_price_per_quota: '656,25 €',
          },
          {
            color: '#6E8DB5',
            name: '500 Kontakte',
            price_per_contact: '3,00 €',
            discounted_price_per_contact: '2,25 €',
            price_per_quota: '1.500,00 €',
            discounted_price_per_quota: '1.125,00 €',
          },
          {
            color: '#3D6190',
            name: '1000 Kontakte',
            price_per_contact: '2,50 €',
            discounted_price_per_contact: '1,88 €',
            price_per_quota: '2.500,00 €',
            discounted_price_per_quota: '1.875,00 €',
          },
        ],
      };
    },
  };
